<template>
    <div :style="myStyle" class="up_pull_refresh" :class="{loader_back:loaderBack}">
        <div class="up_pull_refresh_content">
            <div class="tip">
                <span v-if="showType==1">下拉可以刷新</span>
                <span v-if="showType==2">释放立即刷新</span>
                <span v-if="showType==3">正在刷新...</span>
                <span v-if="showType==4">刷新完成</span>
                <br />
                <span class="time">
                    上次更新 {{time}}
                </span>
            </div>
            <div v-if="showType==3" class="now_refresh">
                <div class="loaders">
                    <div class="loader-inner line-spin-fade-loader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import "loaders.css"
export default {
    name: "pullDownRefresh",
    props: {
        loader: {}
    },
    data() {
        return {
            isTouchMove: false,
            loaderHeight: 0,
            touchMoveStartY: 0,
            loaderHeight: 0,
            maxHeight: 0,
            showType: 1,
            nowFreshLoad: false,
            loaderBack: false,
            time: this.formatDate(new Date(), "MM-dd HH:mm")
        }
    },
    mounted() {

        this.getMaxHeight();
        this.watchTouchMove();
    },
    methods: {
        /**
         * [watchTouchMove description] 监听touchmove事件
         * @return {[type]} [description]
         */
        watchTouchMove() {
            let self = this;
            this.$el.parentElement.addEventListener("touchmove", e => {
                if (self.$el.parentElement.scrollTop != 0) return;
                if (self.nowFreshLoad) return;
                //$(self.$el).parent().eq(0).css("touch-action", 'none');
                if (self.touchMoveStartY == 0) {
                    self.touchMoveStartY = e.touches[0].clientY * 1;
                }
                let loaderHeight = e.touches[0].clientY - self.touchMoveStartY;
                loaderHeight = loaderHeight < 0 ? 0 : loaderHeight * 0.4;
                self.isTouchMove = loaderHeight > self.maxHeight ? true : false;
                self.showType = loaderHeight > self.maxHeight ? 2 : 1;
                self.loaderHeight = loaderHeight;

            });
            this.$el.parentElement.addEventListener("touchend", e => {
                self.touchMoveStartY = 0;
                if (!self.isTouchMove) {
                    self.loaderHeight = 0;
                    return;
                }
                //$(self.$el).parent().eq(0).css("touch-action", '');
                self.isTouchMove = false;
                self.nowFreshLoad = true;
                self.showType = 3;
                self.loaderHeight = self.maxHeight;
                self.loaderBack = true;
                self.$emit('upPull');
            });
        },
        /**
         * [getMaxHeight description] 获取极限高度
         * @return {[type]} [description]
         */
        getMaxHeight() {
            this.maxHeight = $(this.$el).find(".up_pull_refresh_content").height();
        }
    },
    computed: {
        myStyle() {
            return {
                height: this.loaderHeight + 'px'
            }
        }
    },
    watch: {
        loader(newV, oldV) {
            if (!newV) return;
            newV.then(() => {
                this.time = this.formatDate(new Date(), "MM-dd HH:mm");
                this.showType = 4;
                setTimeout(() => {
                    this.nowFreshLoad = false;
                    this.showType = 1;
                    this.loaderHeight = 0;
                    setTimeout(() => {
                        this.loaderBack = false;
                    }, 200);
                }, 800);
            });
        }
    }
}
</script>
<style lang='less'>
.up_pull_refresh {
    width: 100%;
    overflow: hidden;
    background: #F9F7F8;
    color: #242424;
    position: relative;
    &.loader_back {
        transition: height .1s;
    }

    .up_pull_refresh_content {
        width: 100%;
        height: 0.8rem;
        text-align: center;

        .tip {
            width: 100%;
            height: 0.8rem;
            padding-top: 0.26rem;

            span {
                font-size: 0.14rem;

                &.time {
                    font-size: 0.1rem;
                    color: #7D7D7D;
                }
            }
        }



        .now_refresh {
            position: absolute;
            left: 0;
            top: 0;

            .loaders {
                float: left;
                transform-origin: 50% 50%;
                position: relative;
                height: 0.84rem;
                line-height: 0.83rem;
                width: 0.84rem;
                transform: scale(0.4);
                margin-left: 0.7rem;
                top: -0.03rem;
                left: -0.06rem;

                .line-spin-fade-loader {
                    top: 0.31rem;
                    left: 0.36rem;

                    &>div {
                        background: #242424;

                    }
                }
            }

        }
    }
}
</style>